export default {
  computed: {
    filterSearchSystem: function () {
      return this.filteredData.filter((systems) => {
        const searchSystem = new RegExp(this.searchSystem, "i");
        return systems.system.id?.match(searchSystem) || systems.system.alarmemail?.match(searchSystem) || systems.system.alarmsms?.match(searchSystem) || systems.system.sewertype?.match(searchSystem) || systems.system.city?.match(searchSystem) || systems.system.address1?.match(searchSystem);
      })
    },

    filterSearchUser: function () {
      // if(this.authLevel === "3"){
      return this.filteredDealerUsers.filter((dealers) => {
        const searchUser = new RegExp(this.searchUser, "i");
        return dealers.email?.match(searchUser) || dealers.city?.match(searchUser) || dealers.address1?.match(searchUser) || dealers.cvr?.match(searchUser) || dealers.name?.match(searchUser) || dealers.companyname?.match(searchUser) || dealers.zip?.match(searchUser);
      })
      // } else {
      //   return this.dealerUsers.filter((dealers)=>{
      //     const searchUser = new RegExp(this.searchUser, "i");
      //     return dealers.email?.match(searchUser) || dealers.city?.match(searchUser) || dealers.address1?.match(searchUser) || dealers.cvr?.match(searchUser) || dealers.name?.match(searchUser) || dealers.companyname?.match(searchUser);
      //   })
      // }
    }

  },
}